import { PartnerGroupRules, UserGroupRules } from './group-rules.types';

export const hasPlatformPartnerAccess = (
  groupRules: Partial<Record<PartnerGroupRules | UserGroupRules, boolean | number[]>>,
): boolean => Boolean(groupRules[UserGroupRules.AccessToPlatformPartner]);

export const hasNonBpoPartnerAccess = (
  groupRules: Partial<Record<PartnerGroupRules | UserGroupRules, boolean | number[]>>,
): boolean => Boolean(groupRules[UserGroupRules.AccessToNonBpoPartners]);

export const canUpdateConversationUrgency = (
  groupRules: Partial<Record<PartnerGroupRules | UserGroupRules, boolean | number[]>>,
): boolean => groupRules[UserGroupRules.AccessToUpdateConversationUrgency] === true;
